import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class BasesStore {
    constructor(baseService) {
        this.baseService = baseService;
        this.loading = false;
        this.initializeBaseFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию базы...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: {
                search: "",
            },
            dataLoader: {
                loadData: (params) => this.loadBases(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeBaseFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadBases(params) {
        try {
            const result = await this.baseService.getBasesWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteBase(id) {
        this.setLoading(true);
        try {
            await this.baseService.deleteBase(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting base");
        }
        finally {
            this.setLoading(false);
        }
    }
}
